/* KBM Swatch Price Fix - safety net: replace product card prices that show $5 (Swatch) with the actual yard price.
   v40: primary fix now happens server-side / in each widget renderer; this remains as a catch-all.
        Extended coverage: pairs-with cards, cart upsell cards, drawer cross-sell cards.
   Strategy: find product cards displaying "$5.00", fetch the product JSON, find the first non-swatch variant price, replace.
   Runs once on DOM ready and on any product card injection. */
(function(){
  var cache = {};
  var CARD_SEL = '.pg-card, .product-card, .related-product-card, .kbm-rv-card, .kbm-pair-card, .kbm-upsell-card, .kdx-card, .kbm-rib-up-card, .kbm-drawer__crosssell-card';
  function getProductHandle(card){
    var link = card.tagName === 'A' ? card : card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : null;
  }
  function findPriceEl(card){
    return card.querySelector('.pg-price, .product-card-price, .price, [data-price-display], .kbm-rv-price, .kbm-pair-card__price, .kdx-price, .kbm-rib-up-price');
  }
  function formatMoney(cents){
    var dollars = (parseFloat(cents) / 100).toFixed(2);
    return '$' + dollars;
  }
  function fixCard(card){
    var handle = getProductHandle(card);
    if (!handle) return;
    var priceEl = findPriceEl(card);
    if (!priceEl) return;
    /* Only fix if currently showing $5.00 (the swatch price) */
    if (priceEl.textContent.indexOf('$5.00') === -1) return;
    var hadYd = priceEl.textContent.indexOf('/yd') !== -1 || priceEl.textContent.indexOf('/ yd') !== -1;

    var done = function(product){
      if (!product || !product.variants) return;
      var nonSwatch = product.variants.find(function(v){
        var title = (v.title || '').toLowerCase();
        var sku = (v.sku || '').toUpperCase();
        return title.indexOf('swatch') === -1 && title.indexOf('sample') === -1 && sku.indexOf('-SWATCH') === -1;
      });
      if (!nonSwatch) return;
      /* Build the new price markup, preserving compare price logic */
      var compareHTML = '';
      if (nonSwatch.compare_at_price && nonSwatch.compare_at_price > nonSwatch.price) {
        compareHTML = '<span class="pg-compare compare-price" style="text-decoration:line-through;color:#888;margin-right:6px;font-weight:400;font-size:12px;">' + formatMoney(nonSwatch.compare_at_price) + '</span>';
      }
      priceEl.innerHTML = compareHTML + formatMoney(nonSwatch.price) + (hadYd ? '/yd' : '');
    };

    if (cache[handle]) {
      done(cache[handle]);
      return;
    }
    fetch('/products/' + handle + '.js').then(function(r){ return r.json(); }).then(function(p){
      cache[handle] = p;
      done(p);
    }).catch(function(){});
  }
  function fixAll(){
    var cards = document.querySelectorAll(CARD_SEL);
    cards.forEach(fixCard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixAll);
  else fixAll();
  /* Watch for late renders (lazy-loaded grids, quick-shop modals, recently viewed, drawer cross-sell) */
  var mo = new MutationObserver(function(muts){
    muts.forEach(function(mut){
      mut.addedNodes.forEach(function(n){
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches(CARD_SEL)) fixCard(n);
        if (n.querySelectorAll) n.querySelectorAll(CARD_SEL).forEach(fixCard);
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
